import { Box, Card, CardContent, styled, ToggleButton, ToggleButtonGroup } from '@mui/material';

// Note: do NOT add `theme` here — styled() always supplies it, and declaring it
// as optional shadows that and forces defensive `theme?.` access.
type Props = {
    isOneOffer: boolean | undefined;
};

export const ToggleGroup = styled(ToggleButtonGroup, { shouldForwardProp: (prop) => prop !== 'isOneOffer' })<Props>(
    ({ isOneOffer }) => ({
        display: 'flex',
        justifyContent: isOneOffer ? 'center' : 'space-evenly',
        gap: '8px',
    }),
);

export const CustomToggleButton = styled(ToggleButton, { shouldForwardProp: (prop) => prop !== 'isOneOffer' })<Props>(
    ({ theme, isOneOffer }) => ({
        border: 'none',
        backgroundColor: 'unset',
        padding: 0,
        borderBottomLeftRadius: '20px',
        width: '100%',

        '&.Mui-selected': {
            backgroundColor: theme.palette.grey[50],
            borderRadius: '20px',
            border: !isOneOffer ? `2px solid ${theme.palette.primary.main}` : undefined,
        },
        '&:hover': {
            backgroundColor: theme.palette.grey[50],
        },
        '&.Mui-selected:hover': {
            backgroundColor: '#E1E7EB',
        },
        '&.Mui-disabled': {
            border: 'none',
        },
    }),
);

export const StyledCard = styled(Card, { shouldForwardProp: (prop) => prop !== 'isOneOffer' })<Props>(
    ({ isOneOffer }: Props) => ({
        height: isOneOffer ? '172px' : '212px',
        width: '100%',
    }),
);

export const StyledCardContent = styled(CardContent)(() => ({
    textAlign: 'left',

    '&:last-child': {
        paddingBottom: '16px',
    },
}));

export const ContentHeader = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
}));

export const Contet = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '8px',
}));
